import React from "react";
import { useAuth } from "../lib/auth";
import { InternalAdminLayout } from "./InternalAdmin";
import MasterProductImagesPanel from "../components/admin/MasterProductImagesPanel";

/**
 * Internal Admin -> Master Product Images (Sep 2026).
 *
 * Rudras-AI-owned product images and their MANUAL association with a
 * tenant product. Super admin only — enforced server-side by `get_super`
 * on every `/api/internal-admin/master-product-images` route; the role
 * check below only avoids showing other internal roles controls that
 * would fail. Technical Handbook, Volume 4 §2.7.11.
 */
export default function InternalMasterProductImages() {
  const { user } = useAuth();
  return (
    <InternalAdminLayout>
      <div className="space-y-2 mb-6">
        <h1 className="font-display text-3xl font-semibold">Master Product Images</h1>
        <p className="text-sm text-muted-foreground max-w-3xl">
          Product images owned by Rudras-AI. A tenant product can be manually associated with one of
          these images; the tenant may display or unlink it, but can never change or delete it.
          Retiring an image stops new associations and never deletes the stored file.
        </p>
      </div>
      <MasterProductImagesPanel canManage={user?.role === "super_admin"} />
    </InternalAdminLayout>
  );
}
